module.exports = __webpack_public_path__ + "img/cartoon-jacob-04.eba8e185.jpg";